'use strict';

module.exports = {

    /**
     * Appends theatMetrix script to the body of the page
     * @param {string} options.deviceId users deviceId
     * @param {string} options.pageId pageId to send to threatmetrix
     * @param {string} options.orgId orgId to send to threatmetrix
     */
    appendKountToBody: function appendKountToBody(options) {
        var sessionId = options.sessionId;
        var merchantId = options.merchantId;
        var pathToHTM = options.pathToHTM;
        var pathToImg = options.pathToImg;

        var iframe = document.querySelector('#spicy-nuggs') || { remove: function remove() {} };
        iframe.remove();

        var frame = document.createElement("iframe");
        frame.width = 1;
        frame.height = 1;
        frame.frameBorder = 0;
        frame.scrolling = 'no';
        frame.src = pathToHTM + '?m=' + merchantId + '&s=' + sessionId;

        var image = document.createElement('img');
        image.height = 1;
        image.width = 1;
        image.src = pathToImg + '?m=' + merchantId + '&s=' + sessionId;

        var container = document.createElement("div");
        container.style.display = "none";
        container.id = 'spicy-nuggs';
        container.appendChild(frame);
        frame.appendChild(image);

        document.body.appendChild(container);
        document.body.appendChild(container);
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/kount.js
// module id = 847
// module chunks = 0